"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlotArea = void 0;
const full_clip_space_range2d_1 = require("../transforms/full-clip-space-range2d");
/**
 * @public
 * {@inheritDoc IPlotArea}
 */
class PlotArea {
    constructor(wholeRange, interactiveRange) {
        this.wholeRange = wholeRange;
        this.interactiveRange = interactiveRange;
    }
    static createOneWithMargins(wholeArea, margins) {
        const interactiveArea = margins.getInnerRange(wholeArea);
        return new PlotArea(wholeArea, interactiveArea);
    }
    static createDefault() {
        return new PlotArea(full_clip_space_range2d_1.fullClipSpaceRange2d.slice(), full_clip_space_range2d_1.fullClipSpaceRange2d.slice());
    }
}
exports.PlotArea = PlotArea;
//# sourceMappingURL=i-plot-area.js.map